/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_New_DescInputs */

const en_plan_choose_new_desc = /** @type {(inputs: Plan_Choose_New_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write the PRD, features and tasks from your idea. No code needed.`)
};

const id_plan_choose_new_desc = /** @type {(inputs: Plan_Choose_New_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun PRD, fitur, dan task dari idemu. Tanpa kode.`)
};

/**
* | output |
* | --- |
* | "Write the PRD, features and tasks from your idea. No code needed." |
*
* @param {Plan_Choose_New_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_new_desc = /** @type {((inputs?: Plan_Choose_New_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_New_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_new_desc(inputs)
	return en_plan_choose_new_desc(inputs)
});